export const STATUSES = [
  { label: "New", value: "new" },
  { label: "In Progress", value: "in progress" },
  { label: "Won", value: "won" },
  { label: "Lost", value: "lost" }
];
